

 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

export  const    leadCard1Object = { no:1, 
    id: generateTimestamp()+3,
    cardName:"LeadInfoCard1",
    cardType:"editable",
    myKey:`id-LeadInfoCard1-layout`,
     formTitle:{title:"Hey There!, whats up? ",subtitle:"Please provide your details for your inquiry",info:"Unlock offers!!!",status:true},
   
     fullname:{title:"Your Full Name:",placeholder:"Your name",status:true},
     email:{title:"Your Email :",placeholder:"you@example.com",},
     mobile:{title:"Your Mobile No:",placeholder:"+91 98765 43210",status:true},
     city:{title:"Your Current City:",placeholder:"Mumbai",status:true},
     message:{title:"Type Message Here",placeholder:"Tell us what you need help with",
      status:true},
  buttonText:{title:"Send me info",info:"Info will be sent on your email",
      },
     checkBoxText:{title:"I agree to be contacted about my request",status:true
      },
   
     education:{title:"Provide Your Educational Details:",status:true,
     type:"school",
     school:{status:true,
      title:"In Which Class Are You Currently Studing?",
      class:10, },
     diploma:{status:true,
      title:"In Which Year of Your Diploma Are You Currently Studing?",
      diplomaName:"Diploma In Electrical Engineering",
      currentYear:1, 
     },
      graduation:{status:true,
      title:"In Which Year of Your Graducation Are You Currently Studing?",
    
      degreeName:"BTech In Electrical Engineering",
      currentYear:1,

     },
      pg:{status:true,
      title:"In Which Year of Your Post Graducation Are You Currently Studing?",
    
      pgName:"PG In Economics",
      currentYear:1,

     }
      },
 image: {         title:"Join Us Now",
                  status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg",
                  s3Key:"",
                   aspectRatio:{title:"Image Crop Ratio",value:"3/4"},
         borderRadius:{title:"Lead Card Image Radius",
        topLeft:{title:"Top Left Radius",value:150,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:30,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
      
                },
                  buttonBG:{title:"Button Background Color",color:"rgba(139, 255, 239, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
   layoutBGRight:{title:"Right Layout Background Color",color:"rgba(235, 250, 250, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
  layoutBGLeft:{title:"Left Layout Background Color",color:"rgba(229, 253, 226, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
   titleColor:{title:"Title Color",color:"rgba(23, 23, 23, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
  
  subtitleColor:{title:"Subtitle ,Tags & Label Color",color:"rgba(77, 80, 76, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
       titleFont:{  family:{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 } }, subtitleFont:{  family:{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 } },
 
              borderImage:{title:"Image  Border",borderType:"double",borderWidth:{title:"Border Width",value:25,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
         borderButton:{title:"Button  Border",borderType:"solid",borderWidth:{title:"Border Width",value:4,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
         borderInput:{title:"Input  Border",borderType:"dashed",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Input Border Color",color:" rgba(171, 249, 165, 0.7)",colors:{},alpha:1}},
 borderCard:{title:"Image  Border",borderType:"double",borderWidth:{title:"Border Width",value:25,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(230, 252, 248, 1)",colors:{},alpha:1}},
 button: {
                       borderRadius:{title:"Lead Card Button Radius",
        topLeft:{title:"Top Left Radius",value:150,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:30,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
         border:{title:"Image  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(255, 255, 255, 0.93)",colors:{},alpha:1}},

                } ,

                


    
    mirrorItems:{title:"Mirror Card Items",status:false},
    layoutShadow:{title:"Card Shadow",horizontal:{title:"Horizontal",value:0,resolution:"%"},vertical:{title:"Vertical",value:0,resolution:"%"},blur:{title:"Blur",value:0,resolution:"%"},spread:{title:"Spread",value:30,resolution:"%"},shadowColor:{title:"Image Shadow Color",color:"rgba(255, 255, 255, 0.23)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1},inset:false} ,


     thankYouPage:{
      title:"Thank You!!!",
      description:"We Appreciate Your Interest In Our Courses.",
       cardBG:{title:"PopUp Card BG Color",color:"rgba(250, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
  
      titleColor:{title:"Title Color",color:"rgba(23, 23, 23, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
  
  subtitleColor:{title:"Subtitle ,Tags & Label Color",color:"rgba(77, 80, 76, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
 
  titleFont:{  family:{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 } },
  subtitleFont:{  family:{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 } },    
 

      addCTA:true,
      CTAButton:{
      title:"Choose CTA Action ",
      type:"refer",
      refer:{title:"Refer And Become Our Evangelist.",buttonTitle:"Refer And Earn."
        ,description:"Share With Your Friends And Earn. Also Get Access To Our Exclusive Paid Courses For Free."
        ,buttonBG:{title:"Buttom BG Color",color:"rgba(0, 0, 0, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
 },
      connectWithUs:{ title:"Connect With Us.",description:"Follow Our Pages & Stay Updated With Our Anouncements.",
        fb:{link:""},YT:{link:""},Insta:{link:""},X:{link:""},links:[{link:""},{link:""}]},
      freeDownload:{ title:"We Have Exclusive  Free Resourses For You.",description:"Get Access To All Free  Resources Now.",
        buttonTitle:"Send To My Email"
        ,buttonBG:{title:"Buttom BG Color",color:"rgba(0, 0, 0, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
 
        info:"*Link is valid for 1 Hour only",
        item:"pdf",// pdf ,doc,ppt ,zip
        downloadType:"sendToEmail", // sendToEmail, Instant
        s3Key:"",
        linkValidFor:{value:1,dutation:"hour",} // hour , minute, days
        
      },
      joinWebinar:{title:"You Can Join Our Free Upcoming Webinar.",description:"Only Few Seats Remaining.",
        btnTitle:"Send me webinar details",
        timer:true,
        info:"",
        webinarId:""},
      freeTest:{title:"We Have Exclusive Free Mock  For You .",description:"Access Your Level With This Test.",
        btnTitle:"Start Test",
        info:"",
        testId:""},
      freeCourse:{title:"We Have Exclusive Free Course For You.",description:"Get Access To All Free Lectures And Resources With This Course .",
        btnTitle:"Enrol Into This Course ",
        info:"",
        courseId:""},
      upsell:{ title:"We Have Exclusive Offer For You.",description:"Get Access To All  Lectures And Resources With This Course .",
        btnTitle:"Buy This Course ",
        info:"Offer Valid Till Midnignt Only",
        timer:true,
        courseId:""
      },
      joinGroup:{title:"Join Our Community .",description:"Stay Updated With Anouncements And Connect With Students.",
        telegram:{ title:"Join Telegram Group",groupLink:""},
        facebook:{  title:"Join FB Group",groupLink:""},
        whatsapp:{  title:"Join Whatsapp Group",groupLink:""}
      },
      newsLetter:{ title:"Subscribe To Our Newslater.",description:"Get Early Access To Our Exclusive Courses"}
      ,couponCode:{
        title:"We Have Sepecial Coupon For You.",description:"Please Use it before it expires.",
        info:"Coupon Valid Till Midnignt Only",
        timer:true,
        couponId:""
      }
       , walletRecharge:{  title:"Congrats! You have been awarded wallet credits worth 100Rs.",
        description:"feel free to claim your credits.",
        info:"You can buy courses, tests or ebooks using wallet credits.",
        walletCreditId:""} 

    },
     },

        


            
     
                       
         
        }